export const mockData = {
  fileWebName: "File name.xlsx",
  fileWebExpiredName: "File name.xlsx",
};
